import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { menuCode, policyFilterMessage } from '../../shared/constants/Strings';
import { Coverage } from '../../shared/constants/Coverage';
import { fixStructBase64, getOptionsToProduct, dateNowFormatted, getProductInfo } from '../../../util/Util';
import { createErrorPage } from '../../redux/auth';
import GenericConstancyServices from '../../shared/services/GenericConstancyServices';

import { GAProvider } from '../../components/PSAnalytics';
import PSBodyProduct from '../../components/PSBodyProduct';
import { FrequentQuestions } from '../../shared/constants/FrequentQuestions';

import './index.scss';

const img = 'product-SCTR';
const imgMobile = 'product-SCTR-mobile';

const headerTableFather = [
  { elementProp: 'shortDescription', headerColumn: 'Producto' },
  { elementProp: 'nroPolicy', headerColumn: 'Póliza' },
  { elementProp: 'rol', headerColumn: 'Rol' },
  { elementProp: 'dateVigencia', headerColumn: 'Vigencia' },
];

export default function HomeProductSCTR(props) {
  const [paramsComprobantes, setParamsComprobantes] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingOption, setLoadingOption] = useState(true);
  const { userInfo } = useSelector((state) => state.auth);
  const ga = React.useContext(GAProvider);
  const [options, setOptions] = useState([]);

  const isBusiness = userInfo ? userInfo.isBusiness : false;
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [currentCode, setCurrentCode] = useState(null);
  const [fileBase64, setFileBase64] = useState({});
  const {
    product: menuId,
    policies
  } = getProductInfo(userInfo?.productsDetail, menuCode.SCTR);  const dispatch = useDispatch();
  const policiesMessage = policyFilterMessage.sctr;

  const getOptionsAvailable = (rol = 'Asegurado') => {
    const option = [];
    if (
      process.env.REACT_APP_PERMISSION_PRODUCT_SCTR_CONSTANCIA_ASEGURADO === 'true' &&
      !isBusiness &&
      rol.trim() !== 'Contratante'
    ) {
      option.push('CDA');
    }
    if (process.env.REACT_APP_PERMISSION_SHOW_ASEGURADOS === 'true' && isBusiness) {
      option.push('CDLA');
    }
    if (process.env.REACT_APP_PERMISSION_SHOW_ASEGURADOS === 'true' && isBusiness) {
      option.push('CICA');
    }
    if (process.env.REACT_APP_PERMISSION_PRODUCT_SCTR_DESCARGA_COMPROBANTE_PAGO === 'true') {
      option.push('DCP');
    }
    if (process.env.REACT_APP_PERMISSION_PRODUCT_SCTR_DESCARGA_POLIZA === 'true') {
      option.push('DP');
    }
    setOptions(option);
  };

  const getComprobantePago = () => {
    if (currentIndex !== -1) {
      const { nbranch, idProduct, nroPolicy, nroCertificate } = policies[currentIndex];
      const data = {
        'branch-id': parseInt(nbranch),
        'product-id': parseInt(idProduct),
        policy: nroPolicy,
        certificate: nroCertificate,
      };
      setParamsComprobantes(data);
    }
  };
  const getConstanciaUserNatural = async (policyCurrent) => {
    try {
      setLoadingOption(true);
      const { attributes: user, documentType, document: documentNumber } = userInfo;
      const dateFormatted = dateNowFormatted();
      const params = {
        data: {
          arrayBoletas: [
            {
              documentType,
              clientName: user?.legalName || '',
              documentNumber,
              initValidity: policyCurrent?.dateStart,
              finishValidity: policyCurrent?.dateEnd,
              policy: policyCurrent?.nroPolicy.toString().padStart(10, '0'),
              policyType: `Seguro de ${policyCurrent?.producto.trim()}`,
              ammount: 'Según condiciones de la Póliza',
              dateDescription: `Surquillo, ${dateFormatted}`,
            },
          ],
          enviarEmail: false,
        },
      };
      const headers = { 'segment-id': menuId };
      const { data, status } = await GenericConstancyServices.responseDocumentUserNatural(
        params,
        headers
      );
      if (data && status === 200) {
        const fixBase64 = fixStructBase64(data.document);
        setFileBase64.CDA = fixBase64;
      } else {
        setFileBase64.CDA = null;
      }
    } catch (error) {
      setFileBase64.CDA = null;
      dispatch(createErrorPage());
    } finally {
      setFileBase64({ ...setFileBase64 });
      setLoadingOption(false);
    }
  };
  useEffect(() => {
    const messageTypeUser = isBusiness ? 'EMPRESA-' : 'PERSONA-';
    ga.pageview(window.location.pathname + window.location.search);
    ga.event({
      category: `${messageTypeUser}Producto SCTR`,
      action: 'click',
      label: 'El usuario visitó la página de SCTR',
      value: 1,
    });
  }, [ga]);

  useEffect(() => {
    if (currentIndex !== -1) {
      const policyCurrent = policies[currentIndex];
      getOptionsAvailable(policyCurrent.rol);
      if (currentCode === 'CDA') {
        getConstanciaUserNatural(policyCurrent);
      }
      if (currentCode === 'DCP') {
        getComprobantePago();
      }
    }
  }, [currentIndex, currentCode]);

 
  return (
    <div className="home-sctr-container">
      <PSBodyProduct
        questions={FrequentQuestions.SCTR}
        coverages={Coverage.SCTR}
        paramsComprobantes={paramsComprobantes}
        img={img}
        imgMobile={imgMobile}
        descriptionHeader="SCTR"
        iconHeader="riesgo"
        loading={loading}
        data={policies}
        options={getOptionsToProduct(options)}
        fileBase64={fileBase64}
        headerTable={headerTableFather}
        onSelectItem={(item) => setCurrentIndex(item)}
        onSetCurrentCodeForm={setCurrentCode}
        loadingOption={loadingOption}
        policiesMessage={policiesMessage}
        useDigitalPolicy
        menuId={menuId}
        {...props}
      />
    </div>
  );
}
